import script from "./UpdateAvailableBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateAvailableBanner.vue?vue&type=script&setup=true&lang=js"

import "./UpdateAvailableBanner.vue?vue&type=style&index=0&id=5a0f1da2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a0f1da2"]])

export default __exports__